import {
    Menu,
    Dropdown,
    MenuItemProps,
    DropdownItemProps,
} from "semantic-ui-react"


export enum MenuType { Menu, Dropdown }

interface MenuProps {
    menuType?: MenuType
}

export function MenuItem(props: MenuProps & MenuItemProps & DropdownItemProps) {
    const { menuType, ...newProps } = props
    return menuType === MenuType.Menu
        ? <Menu.Item {...newProps}>{props.children}</Menu.Item>
        : <Dropdown.Item {...newProps}>{props.children}</Dropdown.Item>
}
